var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFog(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1360,
    height: 80,
    viewBox: "0 0 1360 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1360,
    height: 80,
    rx: 12,
    fill: "#286897"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_568_289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1360,
    height: 80
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1360,
    height: 80,
    rx: 12,
    fill: "#286897"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_568_289)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_568_289)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1243.22 0.010601C1246.61 -23.7406 1267.04 -42 1291.73 -42C1307.81 -42 1322.09 -34.2481 1331.02 -22.2761C1334.88 -23.5136 1339 -24.1818 1343.27 -24.1818C1365.41 -24.1818 1383.36 -6.23251 1383.36 15.9091C1383.36 38.0507 1365.41 56 1343.27 56H1291.73H1244H1240.18V55.7418C1226.52 53.8796 1216 42.1688 1216 28C1216 12.7962 1228.12 0.422672 1243.22 0.010601Z",
    fill: "#558CB4",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_568_289)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1192.22 54.0106C1195.61 30.2594 1216.04 12 1240.73 12C1256.81 12 1271.09 19.7519 1280.02 31.7239C1283.88 30.4864 1288 29.8182 1292.27 29.8182C1314.41 29.8182 1332.36 47.7675 1332.36 69.9091C1332.36 92.0507 1314.41 110 1292.27 110H1240.73H1193H1189.18V109.742C1175.52 107.88 1165 96.1688 1165 82C1165 66.7962 1177.12 54.4227 1192.22 54.0106Z",
    fill: "#558CB4",
    fillOpacity: 0.6
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_568_289",
    x: 1212,
    y: -46,
    width: 175.364,
    height: 106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_568_289"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_568_289",
    x: 1161,
    y: 8,
    width: 175.364,
    height: 106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_568_289"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFog);
export default __webpack_public_path__ + "static/media/fog.cee462810b2a7c8696b7701170241a66.svg";
export { ForwardRef as ReactComponent };